module.exports = __webpack_public_path__ + "img/profile-cover.cee60cfd.jpg";